import React from 'react';
import S from './styles';
import gom from '../../resources/gom.jpeg';
import ahn from '../../resources/ahn.jpeg';
import leo from '../../resources/leo.jpeg';
import ever from '../../resources/ever.png';
import dsunny from '../../resources/dsunny.jpeg';
import james from '../../resources/james.jpeg';
import { SpeakerItem } from "../speaker-item"

const speakerList = [
  {
    name: '민소네',
    company: '카카오뱅크',
    profile: ahn,
    email: 'jungminahn.minsone@gmail.com',
    git: 'https://github.com/minsone',
    blog: 'https://minsone.github.io',
    summary: '은행원',
  }, {
    name: '곰튀김',
    company: 'n.code',
    profile: gom,
    email: 'iamchiwon@gmail.com',
    git: 'https://github.com/iamchiwon',
    blog: 'https://iamchiwon.github.io/',
    youtube: 'https://www.youtube.com/channel/UCsrPur3UrxuwGmT1Jq6tkQw',
    summary: '리얼리즘 프로그래머',
  }, {
        name: '에버(Ever)',
        company: '',
        profile: ever,
        email: 'app_dev@kakao.com',
        git: 'https://github.com/SH4CK3RS',
        summary: '소심한 ENFP 개발자입니다~',
    }, {
        name: '리이오',
        company: '포항공대',
        profile: leo,
        email: 'leeo@kakao.com',
        git: 'https://github.com/M1zz',
        blog: 'https://dev200ok.blogspot.com',
        youtube: 'https://www.youtube.com/channel/UCz03fpnmfEDOZCrE2hwcsUg',
        summary: '개발보다는 협업을 좋아하는 개발자입니다',
    }, {
        name: '디써니(dSunny)',
        company: 'SSG.COM️',
        profile: dsunny,
        email: 'iSunSoo@icloud.com',
        summary: '개발을 좋아하는, 더클회색을 꿈꾸는 ENFP 클라이머입니다🧗🏻‍♂️',
    }, {
        name: '제임스',
        company: '에스알파테라퓨틱스',
        profile: james,
        git: 'https://github.com/inwoodev',
        blog: 'https://velog.io/@inwoodev',
        summary: '호기심 많은 iOS탐험가입니다',
    },
]

export const Speakers = () => (
  <S.Section>
    <S.Title
      id='speakers'
      data-sal="slide-up"
      data-sal-delay="100"
      data-sal-duration="600"
      data-sal-easing="ease"
    >
      Speakers
    </S.Title>
    <S.Wrap>
      { speakerList.map((speaker, index) => (<SpeakerItem speaker={speaker} index={index} key={speaker.name} />))}
    </S.Wrap>

  </S.Section>
)
